import React from 'react'
import {
  getBetLoopFeedPostsRemovedTopic,
  isFollowMeFeedPostRemovePayload,
  iotSubscribeTopics,
  iotUnsubscribeTopics,
} from '@core/State/PushData'
import { patchFeedDataShareWithBettingClosed } from '@core/Areas/BetLoop/helpers/patchCachedData'

export function useSharedBetsTopicSubscription() {
  React.useEffect(() => {
    const topic = getBetLoopFeedPostsRemovedTopic()

    const subscription = iotSubscribeTopics([topic]).subscribe(data => {
      if (!isFollowMeFeedPostRemovePayload(data.payload)) return
      const postId = Number(data.payload.postId)
      if (!postId) return

      patchFeedDataShareWithBettingClosed(postId)
    })

    return () => {
      subscription.dispose()
      iotUnsubscribeTopics([topic])
    }
  }, [])
}
